<template>
    <IonLabel class="hint">
        Deine geleisteten Dienste werden den Kunden in Rechnung gestellt und generieren damit deinen individuellen Umsatz.
    </IonLabel>
    <Skeleton v-if="initialDataLoader.pending.value" :items="['block']"/>
    <template v-else>
        <Blocks>
            <Block v-if="isSet(renderSet.bookings)">
                <template #bigNumber>{{!isSet(renderSet.targetBookings) || renderSet.bookings >= renderSet.targetBookings ? renderSet.bookings : `${renderSet.bookings} / ${renderSet.targetBookings}` }}</template>
                <template #subTitle>{{!isSet(renderSet.targetBookings) || renderSet.bookings >= renderSet.targetBookings ? pluralizeUnitOnly(renderSet.bookings, 'Dienst', 'Dienste') : pluralizeUnitOnly(renderSet.targetBookings, 'Dienst',  'Diensten')}}</template>
            </Block>

            <Block v-if="isSet(renderSet.productiveHours)">
                <template #bigNumber>{{floatFormat(renderSet.productiveHours,1)}}h</template>
                <template #subTitle>Produktiv&shy;stunden</template>
            </Block>

            <Block v-if="isSet(renderSet.revenue)">
                <template #bigNumber>{{money.formatLargeMoney(renderSet.revenue)}}</template>
                <template #subTitle>Umsatz</template>
            </Block>

            <Block v-if="isSet(renderSet.azkAusgleich) && renderSet.azkAusgleich > 0">
                <template #bigNumber>{{renderSet.azkAusgleich}}</template>
                <template #subTitle>{{pluralizeUnitOnly(renderSet.azkAusgleich, 'Tag', 'Tage')}} AZK-A.</template>
            </Block>

            <Block v-if="isSet(renderSet.vacations) && renderSet.vacations > 0">
                <template #bigNumber>{{renderSet.vacations}}</template>
                <template #subTitle>{{pluralizeUnitOnly(renderSet.vacations, 'Tag', 'Tage')}} Urlaub</template>
            </Block>

            <Block v-if="isSet(renderSet.sicknesses) && renderSet.sicknesses > 0">
                <template #bigNumber>{{renderSet.sicknesses}}</template>
                <template #subTitle>{{pluralizeUnitOnly(renderSet.sicknesses, 'Tag', 'Tage')}} Krank</template>
            </Block>
        </Blocks>
    </template>
</template>

<script setup lang="ts">
import {computed, PropType, Ref, ref} from 'vue';
import {DataLoader} from "@/helper/dataLoader";

import Skeleton from "@/components/Skeleton.vue";

import {kapitelMonthString} from '@/graphql/kapitelTypes';
import {floatFormat, pluralizeUnitOnly} from "@/helper/amountFormatter";
import {fetchEmployeeMonthSummary} from "@/helper/employeeMonthSummary";
import {EmployeeMonthSummary, PayrollStatus} from "@/graphql/generated/graphql";
import Blocks from "@/views/components/Blocks.vue";
import Block from "@/views/components/Block.vue";
import {fetchPayrollStatusForMonth} from "@/helper/monthKPI/monthKpiPayroll";
import {isSet} from "@/helper/isset";
import money from "@/helper/money";
import {IonLabel} from "@ionic/vue";

// props
const props = defineProps({
    selectedMonth: {
        type: String as PropType<kapitelMonthString>,
        required: true,
    }
});

const initialDataLoader = new DataLoader();

const employeeMonthSummary : Ref<undefined |EmployeeMonthSummary>= ref(undefined)
initialDataLoader.add(async () => employeeMonthSummary.value = await fetchEmployeeMonthSummary(props.selectedMonth))

const payrollStatus : Ref<undefined | PayrollStatus> = ref(undefined)
initialDataLoader.add(async () => payrollStatus.value = await fetchPayrollStatusForMonth(props.selectedMonth))


const renderSet = computed(() => {
    return {
        productiveHours: employeeMonthSummary.value?.productiveHours ?? null,
        bookings: employeeMonthSummary.value?.cntBookings ?? null,
        targetBookings: employeeMonthSummary.value?.bookingTarget ?? null,
        azkAusgleich: employeeMonthSummary.value?.cntAZKDays ?? null,
        vacations: employeeMonthSummary.value?.cntVacationDays ?? null,
        sicknesses: employeeMonthSummary.value?.cntSicknessDays ?? null,
        revenue: payrollStatus.value?.revenue ?? null,
    }
})

/**
 * raw data
 */


/**
 * reset
 */

const reset = async () => initialDataLoader.reload()
defineExpose({reset})
reset()

</script>

